import React from 'react';
import { CustomDropdown, MultiSelectDropdown } from '../common/index.js';
import { UserActionLabels } from './userActionEnum.js';
import { AggregationModeDropdown } from './ChartCardControls.js';

const InsightsModeFilters = ({
  actionFilterOpen,
  aggregationMode,
  filterBarActionOpen,
  focusedAction,
  getActionOptions,
  getUsersAndTeamsOptions,
  handleActionSelectionChange,
  handleFocusedActionChange,
  handleUserSelectionChange,
  selectedActions,
  selectedUserIds,
  setActionFilterOpen,
  setFilterBarActionOpen,
  setUserFilterOpen,
  showUserCharts,
  userActionOptions,
  userFilterOpen
}) => (
  <>
            <div className="mode-filters">
              {showUserCharts && (
                <MultiSelectDropdown
                  label="Filter Users"
                  options={getUsersAndTeamsOptions()}
                  selectedItems={selectedUserIds || []}
                  onSelectionChange={handleUserSelectionChange}
                  groupBy="type"
                  showSelectAll={true}
                  isOpen={userFilterOpen}
                  toggleDropdown={() => setUserFilterOpen(!userFilterOpen)}
                />
              )}
              <MultiSelectDropdown
                label="Filter Actions"
                options={getActionOptions()}
                selectedItems={selectedActions}
                onSelectionChange={handleActionSelectionChange}
                showSelectAll={true}
                isOpen={actionFilterOpen}
                toggleDropdown={() => setActionFilterOpen(!actionFilterOpen)}
              />
              <CustomDropdown
                label="Focus Action"
                options={userActionOptions}
                selectedOption={UserActionLabels[focusedAction]}
                onSelect={handleFocusedActionChange}
                isOpen={filterBarActionOpen}
                toggleDropdown={() => setFilterBarActionOpen(!filterBarActionOpen)}
                keyExtractor={(option, index) => `focused-action-${option.value || index}`}
              />
              <AggregationModeDropdown
                mode={aggregationMode.mode}
                isOpen={aggregationMode.filterBarOpen}
                onToggle={aggregationMode.toggleFilterBar}
                onSelect={aggregationMode.select}
              />
            </div>
  </>
);

export default InsightsModeFilters;
